<template>
  <div class="panel panel-default">
    <div class="panel-heading">
      Sync By Product
    </div>
    <div class="panel-body">
      <div class="form-inline form-inline--better-spaced form-inline--compact-- form-inline--one-liner--">
        <div class="form-group">
          <label>Reference Type</label>
          <select class="form-control" v-model="referenceType" :disabled="loading">
            <option value="product_id">Product ID</option>
            <option value="inventory_id">Inventory ID</option>
            <option value="part_number">Part Number</option>
          </select>
        </div>
        <div class="form-group">
          <label>Reference #</label>
          <input class="form-control" type="text" v-model="referenceNumber" :disabled="loading" />
        </div>
        <div class="form-group">
          <label>Seller</label>
          <select class="form-control" v-model="sellerId" :disabled="loading">
            <option :value="null">Sellect Seller</option>
            <option v-for="(opt, key) in sellerOptions" :key="key" :value="opt.value" v-html="opt.label"></option>
          </select>
        </div>
        <div class="form-group">
          <button type="button" class="btn btn-default" @click="viewPayload" :disabled="!formIsOk || loading"><i class="fa fa-fw fa-eye"></i> View Payload</button>
        </div>
        <div class="form-group">
          <button type="button" class="btn btn-default" @click="applyPayload" :disabled="!formIsOk || loading"><i class="fa fa-fw fa-paper-plane-o"></i> Send</button>
        </div>
        <div class="form-group">
          <button type="button" class="btn btn-default" @click="clearForm" :disabled="!formIsOk || loading"><i class="fa fa-fw fa-times"></i> Clear</button>
        </div>
      </div>
      <div v-if="!!response">
        <h5>Response</h5>
        <pre>{{ response }}</pre>
      </div>
      <div v-if="!!payload">
        <h5>Payload</h5>
        <pre>{{ payload }}</pre>
      </div>
    </div><!-- .panel-body -->
  </div><!-- .panel -->
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import ApiResponseMixin from '@/plugin/mixin/api-response'

export default {
  name: 'sync-by-product-form-component',
  data() {
    return {
      referenceType: null,
      referenceNumber: null,
      sellerId: null,
      supplierOptions: [],
      response: null
    }
  },
  computed: {
    ...mapState('dropship/supplier/syncInventory', {
      sellerOptions: 'sellerOptions',
      payload: 'payloadByProduct'
    }),
    ...mapGetters('dropship/supplier/syncInventory', {
      isRequestingServer: 'isRequestingServer'
    }),
    formIsOk() {
      return this.referenceType && this.referenceNumber && this.sellerId
    },
    loading() {
      return this.isRequestingServer
    }
  },
  methods: {
    viewPayload() {
      this.$store.dispatch(
        'dropship/supplier/syncInventory/viewPayloadByProduct',
        {
          referenceType: this.referenceType,
          referenceNumber: this.referenceNumber,
          sellerId: this.sellerId
        }
      )
    },
    async applyPayload() {
      this.response = null
      try {
        const response = await this.$store.dispatch(
          'dropship/supplier/syncInventory/applyPayloadByProduct',
          {
            referenceType: this.referenceType,
            referenceNumber: this.referenceNumber,
            sellerId: this.sellerId
          }
        )
        if (response) {
          this.$alertify.success('Inventory synchronized')
        } else {
          this.$alertify.error('Inventory NOT synchronized')
        }
        this.response = response
      } catch (reason) {
        if (this.isResponseError(reason)) {
          this.raiseErrorMessage(reason)
        } else {
          this.$alertify.error('An error was raised while requesting to apply payload.  Message: ' + reason)
        }
        this.response = reason
      }
    },
    clearForm() {
      this.referenceType = null
      this.referenceNumber = null
      this.sellerId = null
      this.$store.dispatch('dropship/supplier/syncInventory/clearPayloadByProduct')
    }
  },
  mixins: [
    ApiResponseMixin
  ]
}
</script>
